const f = {
  color: {
    background: "#ffffffff",
    header: {
      title: "#405261ff",
      description: "#7e8e9eff"
    },
    dangerIcon: "#e54a32ff"
  }
};
export {
  f as modal
};
